import React, { useState } from "react";
import "../CSS/Services.css";

function Services() {
  const [openSection, setOpenSection] = useState(null);
  const [openService, setOpenService] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
    setOpenService(null);
  };

  const toggleService = (index) => {
    setOpenService(openService === index ? null : index);
  };

  const coreServices = [
    {
      title: "Advisory for Renewable & Non-Conventional Energy Companies",
      desc: "Tailored guidance for achieving energy goals and enhancing efficiency in renewable and non-conventional energy sectors.",
    },
    {
      title: "Fundraising Support",
      desc: "Facilitating access to domestic and international climate finance to empower project funding and growth.",
    },
    {
      title: "Financial Modelling & Advisory",
      desc: "Crafting robust strategies for project viability, forecasting, and profitability enhancement.",
    },
    {
      title: "Carbon Credit Advisory",
      desc: "Helping businesses capitalize on carbon credit opportunities through expert consulting.",
    },
    {
      title: "ERP Implementation Support",
      desc: "Providing seamless integration of enterprise resource planning systems for efficient operations.",
    },
    {
      title: "BID/Tender Process Assistance",
      desc: "Offering expert support in project procurement, documentation, and tender management.",
    },
    {
      title: "Project Reporting and Monitoring",
      desc: "Ensuring transparency, accountability, and timely project updates through detailed reporting frameworks.",
    },
    {
      title: "Internal Process/System Development",
      desc: "Establishing policies and frameworks that promote sustainable and efficient business practices.",
    },
  ];

  const extendedOfferings = [
    {
      title: "Regulatory Compliance Advisory",
      desc: "Comprehensive planning for green energy infrastructure development.",
    },
    {
      title: "Green Technology Implementation",
      desc: "Identifying and integrating cutting-edge technologies.",
    },
    {
      title: "Carbon Capture Advisory",
      desc: "Reducing emissions through innovative solutions.",
    },
    {
      title: "ESG Reporting and Advisory",
      desc: "Aligning with Environmental, Social, and Governance benchmarks.",
    },
    {
      title: "Training and Capacity Building",
      desc: "Empowering teams to embrace sustainability practices.",
    },
    {
      title: "Sustainability Audit",
      desc: "Evaluating and enhancing organizational sustainability performance.",
    },
    {
      title: "Green Certifications Assistance",
      desc: "Supporting organizations in obtaining recognized certifications.",
    },
    {
      title: "Climate Risk Assessment",
      desc: "Identifying and mitigating risks associated with climate change.",
    },
  ];

  const additionalServices = [
    {
      title: "Sustainable Supply Chain Advisory",
      desc: "Helping organizations build eco-friendly and efficient supply chains.",
    },
    {
      title: "Renewable Energy Feasibility Studies",
      desc: "Assessing potential projects for their technical and financial viability.",
    },
    {
      title: "Grant Application Support",
      desc: "Assistance in applying for government and international green grants.",
    },
    {
      title: "Digital Transformation for Sustainability",
      desc: "Leveraging IoT, AI, and data analytics for energy management and sustainability.",
    },
    {
      title: "Waste Management Solutions",
      desc: "Advisory and implementation of circular economy practices.",
    },
    {
      title: "Asset Management Distribution",
      desc: "For various Discoms, Energy sector PSU.",
    },
  ];

  const renderServiceList = (list) => (
    <div className="service-list">
      {list.map((item, index) => (
        <div
          key={index}
          className={`service-card ${openService === index ? "active" : ""}`}
          onClick={() => toggleService(index)}
        >
          <div className="service-header">
            <h4>{item.title}</h4>
            <span>{openService === index ? "−" : "+"}</span>
          </div>
          {openService === index && <p className="service-desc">{item.desc}</p>}
        </div>
      ))}
    </div>
  );

  return (
    <div className="services-container">
      <h2 className="services-title">Our Services</h2>
      <p className="services-subtitle">
        Explore our core, extended, and additional service offerings that drive sustainable growth and green innovation.
      </p>

      <div className="services-section">
        <div
          className={`section-header ${openSection === "core" ? "open" : ""}`}
          onClick={() => toggleSection("core")}
        >
          <h3>🌿 Core Services</h3>
          <span>{openSection === "core" ? "−" : "+"}</span>
        </div>
        {openSection === "core" && renderServiceList(coreServices)}
      </div>

      <div className="services-section">
        <div
          className={`section-header ${openSection === "extended" ? "open" : ""}`}
          onClick={() => toggleSection("extended")}
        >
          <h3>🌍 Extended Offerings</h3>
          <span>{openSection === "extended" ? "−" : "+"}</span>
        </div>
        {openSection === "extended" && renderServiceList(extendedOfferings)}
      </div>

      <div className="services-section">
        <div
          className={`section-header ${openSection === "additional" ? "open" : ""}`}
          onClick={() => toggleSection("additional")}
        >
          <h3>⚙️ Additional Services</h3>
          <span>{openSection === "additional" ? "−" : "+"}</span>
        </div>
        {openSection === "additional" && renderServiceList(additionalServices)}
      </div>
    </div>
  );
}

export default Services;
